// ─────────────────────────────────────────────────────────────────────────────
// app/(auth)/login/api/index.ts
// Yazar: Bilge
//
// Login sayfasına ait API yeniden dışa aktarım (re-export) dosyası.
// Bu sayfa özelinde kullanılacak tipler ve hook burada toplanır;
// LoginForm ve useLoginForm yalnızca bu dosyadan import yapar.
//
// Neden bu dosya var?
//   Sayfanın kendi içinde tek giriş noktası oluşturur.
//   authApi'deki değişikliklerin sayfaya etkisi bu dosyadan yönetilir.
// ─────────────────────────────────────────────────────────────────────────────

// LoginParams, AuthUser, AuthTokens gibi tipleri login/types/index.ts'ten aktarır
export * from "../types";

// useLoginMutation: POST /auth/login — authApi.ts'de tanımlı
export { useLoginMutation } from "@/app/lib/api/authApi";